/* docx se učitava kao gotov browser bundle (public/vendor, scripts/copy-vendor.js) — CRA Babel ne prevodi njegov ESM izlaz.
   Učitava se tek kad zatreba (prvi Word izvoz). */
let docxUcitan = null;
export const ucitajDocx = () => {
    if (window.docx) return Promise.resolve(window.docx);
    if (!docxUcitan) {
        docxUcitan = new Promise((resolve, reject) => {
            const sc = document.createElement('script');
            sc.src = `${process.env.PUBLIC_URL || ''}/vendor/docx.iife.js`;
            sc.async = true;
            sc.onload = () => (window.docx ? resolve(window.docx) : reject(new Error('docx nije učitan')));
            sc.onerror = () => { docxUcitan = null; reject(new Error('docx nije učitan')); };
            document.head.appendChild(sc);
        });
    }
    return docxUcitan;
};
